/* eslint-disable @typescript-eslint/quotes */
/* eslint-disable prefer-arrow/prefer-arrow-functions */
/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable max-len */
import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import {
  AlertController,
  ModalController,
  Platform,
  ToastController,
} from '@ionic/angular';
import { ActivatedRoute, Router } from '@angular/router';

import { ActivityFormComponent } from '../../activity/activity-form/activity-form.component';
import { StorageService } from '../../services/storage.service';
import { DataService } from '../../services/data.service';
import { Club } from '../../shared/models';
import { StravaFormComponent } from 'src/app/activity/strava-form/strava-form.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  code: string;
  athlete: any;
  manualLogIn = localStorage.getItem('manualLogIn');
  shouldShowTutorial = true;
  title = 'Settings';
  myToggle = window.matchMedia('(prefers-color-scheme: dark)');
  myToggleStatus = document.body.classList.contains('dark');
  imperialStatus =
    localStorage.getItem('imperial') &&
    localStorage.getItem('imperial') === 'true';
  age: number;
  heartrate: number;
  copyright = '';
  firstLoginLoading = false;
  constructor(
    private authService: AuthService,
    private storageService: StorageService,
    private platform: Platform,
    private route: ActivatedRoute,
    private modalController: ModalController,
    private dataService: DataService,
    private toastController: ToastController,
    private alertController: AlertController,
    private router: Router
  ) {}

  ngOnInit() {
    this.copyright =
      '© ' + new Date().getUTCFullYear() + ' RunnerGram. All rights reserved.';
    if (localStorage.getItem('age')) {
      this.age = parseInt(localStorage.getItem('age'), 10);
    }
    if (localStorage.getItem('heartrate')) {
      this.heartrate = parseInt(localStorage.getItem('heartrate'), 10);
    }

    if (localStorage.getItem('tutorial')) {
      this.shouldShowTutorial = false;
    }
    this.route.queryParams.subscribe((params) => {
      this.code = params.code;
      if (this.code && !this.authService.isLoggedIn) {
        this.firstLoginLoading = true;
        this.authService.login(this.code).subscribe((token) => {
          this.authService.registerUser(token);
          this.athlete = token.athlete;
          this.downloadProfilePhoto(token.athlete.profile);
        },()=>{this.firstLoginLoading = false;});
      } else {
        this.athlete = JSON.parse(localStorage.getItem('athlete'));
      }
    });
  }

  updateProfile() {
    this.dataService.getAthlete().subscribe((athlete) => {
      this.athlete = athlete;
      this.downloadProfilePhoto(athlete.profile);
      this.dataService.downloadAthleteClubs(1);
      localStorage.setItem('athlete', JSON.stringify(athlete));
      this.presentToast('User details have been updated');
      if (this.athlete.measurement_preference !== 'meters') {
        localStorage.setItem('imperial', 'true');
        this.imperialStatus = true;
      }
    });
  }

  toggleImperial() {
    localStorage.setItem('imperial', this.imperialStatus.toString());
  }

  checkToggle() {
    document.body.classList.toggle('dark', this.myToggleStatus);
    localStorage.setItem('darkMode', this.myToggleStatus.toString());
  }

  getBackButtonText() {
    const win = window as any;
    const mode = win && win.Ionic && win.Ionic.mode;
    return mode === 'ios' ? 'Home' : '';
  }

  noStrava() {
    return !localStorage.getItem('access_token');
  }

  isLoggedIn() {
    if (!this.manualLogIn) {
      return this.authService.isLoggedIn;
    }
    return this.manualLogIn;
  }

  // getAthleteStats(){
  //   this.dataService.getAthleteStats(this.athlete.id).subscribe(
  //    stats => console.log(stats)
  //   );
  // }

  markAsRead() {
    localStorage.setItem('tutorial', 'true');
    this.title = 'Settings';
    this.shouldShowTutorial = false;
  }

  showTutorial() {
    this.title = 'Tutorial';
    this.shouldShowTutorial = true;
  }

  loginWithStrava() {
    // eslint-disable-next-line max-len
    const params =
      'client_id=54930&redirect_uri=https://runnergram/login&response_type=code&approval_prompt=auto&scope=profile:read_all,activity:read_all';
    if (this.platform.is('desktop')) {
      window.location.href = 'https://www.strava.com/oauth/authorize?' + params;
    } else {
      window.open('https://www.strava.com/oauth/mobile/authorize?' + params);
    }
  }

  loginWithGarmin() {
    // eslint-disable-next-line max-len
    // const params = 'client_id=54930&redirect_uri=https://runnergram/login&response_type=code&approval_prompt=auto&scope=profile:read_all,activity:read_all';
    // this.authService.garminGetToken().subscribe(token=>{
    // //  console.log(token);
    // });
    // if(this.platform.is('desktop')){
    //   window.location.href = 'https://connectapi.garmin.com/oauth-service/oauth/request_token';
    // } else {
    //   window.open('https://connectapi.garmin.com/oauth-service/oauth/request_token');
    // }
  }

  removeNonFavActivities() {
    this.dataService.needsUpdate = true;
    this.storageService.removeNonFavActivities();
    this.presentToast('Activities have been removed');
  }

  clearData() {
    this.dataService.needsUpdate = true;
    this.storageService.removeAllActivities().then(() => {
     localStorage.removeItem('allItems');
      this.presentToast('All activities have been removed.');
    });
  }

  async askForLogout() {
    const alert = await this.alertController.create({
      header: 'Warning',
      message: 'Are you sure? All your activities and settings will be lost.',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          id: 'cancel-button',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          },
        },
        {
          text: 'Ok',
          id: 'confirm-button',
          handler: () => {
            if (!this.manualLogIn) {
              this.authService.logout();
              this.dataService.needsUpdate = true;
              this.presentToast('Application successfully reset');
            } else {
              this.dataService.needsUpdate = true;
              this.authService.logout();
              this.presentToast('Application successfully reset');
              this.manualLogIn = undefined;
            }
          },
        },
      ],
    });
    await alert.present();
  }

  sendEmail() {
    const link = 'mailto:alex@slowrunners.gr?subject=Runnergram support';
    window.open(link, '_system');
  }

  privacyPolicy() {
    const link = 'https://www.slowrunners.gr/privacy_policy';
    window.open(link, '_system');
  }

  goToHelp() {
    const link = 'https://www.slowrunners.gr/help';
    window.open(link, '_system');
  }

  donate() {
    const link =
      'https://www.paypal.com/donate/?business=SQ59V5MASBXWG&no_recurring=0&item_name=Help+our+developers+get+their+new+running+shoes%21&currency_code=EUR';
    window.open(link, '_system');
  }

   async  updateAge() {
    const okButton = {
      text: 'Ok',
      handler: (value) => {
        if (value[0]!=='') {
          this.age = value[0];
          localStorage.setItem('age', value[0].toString());
        }

      }
    };
    const alert = await this.alertController.create({
      header: 'Enter year of birth',
      buttons: [okButton],
      inputs: [
        {
          placeholder: 'Year of birth',
          value: this.age,
        },
      ],
    });

     await alert.present();

  }

  async updateHeartrate() {
    const okButton = {
      text: 'Ok',
      handler: (value) => {
        if (value[0]!=='') {
          this.heartrate = value[0];
          localStorage.setItem('heartrate', value[0].toString());
        }
      },
    };
    const alert = await this.alertController.create({
      header: 'Enter maximum heartrate',
      buttons: [okButton],
      inputs: [
        {
          placeholder: 'BpM',
          value: this.heartrate,
        },
      ],
    });

    await alert.present();


  }

  checkDisabled() {
    return (
      this.age === parseInt(localStorage.getItem('age'), 10) ||
      this.age < 1900 ||
      this.age > new Date().getUTCFullYear()
    );
  }

  async addStravaActivity() {
    const modalContent = StravaFormComponent;
    const modal = await this.modalController.create({
      component: modalContent,
    });
    modal.onDidDismiss().then((dataReturned) => {
      if (dataReturned.data.data !== null) {
        this.dataService
          .getActivityData(dataReturned.data.data)
          .subscribe((activity) => {
            this.storageService.set(
              Math.floor(
                new Date(activity.start_date_local).getTime() / 1000
              ).toString(),
              activity
            );
            this.dataService.needsUpdate = true;
            this.presentToast('The activity is added in your list');
          });
      }
    });
    return await modal.present();
  }

  async addManualActivity() {
    const modalContent = ActivityFormComponent;
    const modal = await this.modalController.create({
      component: modalContent,
    });

    modal.onDidDismiss().then((dataReturned) => {
      if (dataReturned?.data.data !== null) {
        this.dataService.needsUpdate = true;
        this.overrideSources(dataReturned.data.data);
        this.presentToast('The activity is added in your list');
      }
    });
    return await modal.present();
  }

  private overrideSources(data) {
    data.id =
      'manual' +
      Math.floor(
        new Date(data.start_date_local.toString()).getTime() / 1000
      ).toString();
    localStorage.setItem('manualLogIn', 'true');
    this.manualLogIn = localStorage.getItem('manualLogIn');
    this.storageService.promiseSet(data).then(() => {
      this.router.navigate(['/']);
    });
  }

  private downloadProfilePhoto(url) {
    const reader = this.getFileReader();
    reader.onloadend = () => {
      if (reader.result) {
        localStorage.setItem('profilePhoto', reader.result.toString());
      }
    };
    fetch(url)
      .then((resp) => resp.blob())
      .then((blob) => {
        reader.readAsDataURL(blob);
      })
      .catch(() => this.downloadPrivateProfilePhoto(url));
  }

  private downloadPrivateProfilePhoto(url) {
    const proxy = 'https://wsrv.nl/?url=';
    const reader = this.getFileReader();
    reader.onloadend = () => {
      if (reader.result) {
        localStorage.setItem('profilePhoto', reader.result.toString());
      }
    };
    fetch(proxy + url)
      .then((resp) => resp.blob())
      .then((blob) => {
        reader.readAsDataURL(blob);
      })
      .catch(() => console.log('No public photo'));
  }

  private getFileReader(): FileReader {
    const fileReader = new FileReader();
    const zoneOriginalInstance = (fileReader as any)[
      '__zone_symbol__originalInstance'
    ];
    return zoneOriginalInstance || fileReader;
  }

  private async presentToast(text: string) {
    const toast = await this.toastController.create({
      message: text,
      duration: 2000,
    });
    toast.present();
  }

  private downloadClubPhotos() {
    let element: Club;
    this.dataService.athlete.clubs.forEach((club) => {
      element = club;
      fetch('https://api.allorigins.win/get?url=' + club.profile)
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Couldn't download club logo");
        })
        .then((data) => this.updateClubProfilePhoto(element, data));
    });
  }

  private updateClubProfilePhoto(club, data) {
    //   console.log(data.contents.blob());
    // console.log(this.toBase64(data.contents));
    // const reader = this.getFileReader();
    //   reader.onloadend = function() {
    //     if (reader.result){
    //       console.log(reader.result);
    //       club.profilePhoto = reader.resulst.toString();
    //     }
    //   };
    //   reader.readAsDataURL(blob);
  }

  private toBase64(arr) {
    arr = new Uint8Array(arr); //if it's an ArrayBuffer
    return btoa(
      arr.reduce((data, byte) => data + String.fromCharCode(byte), '')
    );
  }
}
